import { create } from 'zustand';
import { TemperatureData } from '../types/api';

interface TemperatureStore {
  sensors: TemperatureData[];
  setSensors: (sensors: TemperatureData[]) => void;
  updateTemperature: (id: string, temperature: number) => void;
}

export const useTemperatureStore = create<TemperatureStore>((set) => ({
  sensors: [],
  setSensors: (sensors) => set({ sensors }),
  updateTemperature: (id, temperature) =>
    set((state) => ({
      sensors: state.sensors.map((sensor) =>
        sensor.id === id ? { ...sensor, temperature } : sensor
      ),
    })),
})); 